import React from 'react';
import { Peers } from '../../../types/SignalR';
import MainSectionProjectUsers from '../MainSectionProjectUsers/MainSectionProjectUsers';
import MainSectionStreamTextButton from '../MainSectionStreamTextButton/MainSectionStreamTextButton';

import './MainSectionHeader.scss';
import useProject from '../../../hooks/useProject';

type MainSectionHeaderProps = {
  isUserActiveCallback: (userId: string) => boolean;
  isUserLiveCallback: (userId: string) => boolean;
  connectedPeers: Peers;
};

const MainSectionHeader = (props: MainSectionHeaderProps) => {
  const { project } = useProject();

  return (
    <div className="project-main-section__header">
      <MainSectionProjectUsers {...props} />
      <MainSectionStreamTextButton {...project} />
    </div>
  );
};

export default MainSectionHeader;
